import axios from "./axiosConfig";
// import {CancelToken,isCansel} from 'axios'

const upload = (file, link, onUploadProgress, source = { token: null }) => {
  let formData = new FormData();
  formData.append("file", file);

  return axios.post(link, formData, {
    timeout: 300000,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
    cancelToken: source.token,
  });
};

const download = (onDownloadProgress, link) => {
  return axios.get(link, {
    timeout: 300000,
    onDownloadProgress,
  });
};

export default {
  upload,
  download,
};
